import { JupiterTheme, MockHook } from '@jupiterone/jupiter-web-toolkit';
import { createStyles, makeStyles } from '@material-ui/styles';
import React from 'react';
import useAppsIconLogic, { AppsIconComponentProps } from './useAppsIconLogic';
import clsx from 'clsx';

const useStyles = makeStyles((theme: JupiterTheme) => {
  return createStyles({
    appsIconRoot: {
      width: 28,
      height: 28,
      cursor: 'pointer',
      transition: 'stroke 300ms ease-in-out',
      '&:hover ': {
        '& $topLeft': {
          stroke: '#AFF0B7',
        },
        '& $topRight': {
          stroke: '#52E9DF',
        },
        '& $bottomLeft': {
          stroke: '#76ADFF',
        },
        '& $bottomRight': {
          stroke: '#B89AFF',
        },
      },
    },
    topLeft: {
      stroke: '#97D09E',
    },
    topRight: {
      stroke: '#4BC9C1',
    },
    bottomLeft: {
      stroke: '#6199EC',
    },
    bottomRight: {
      stroke: '#9C74FF',
    },
  });
});

export const AppsIconComponent = ({ className }: AppsIconComponentProps) => {
  const classes = useStyles();
  return (
    <>
      <svg
        className={clsx(classes.appsIconRoot, className && className)}
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          className={classes.topLeft}
          d="M10 3H3V10H10V3Z"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M21 3H14V10H21V3Z"
          className={classes.topRight}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M21 14H14V21H21V14Z"
          className={classes.bottomLeft}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          className={classes.bottomRight}
          d="M10 14H3V21H10V14Z"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};

export default MockHook.withHookHoc(AppsIconComponent, useAppsIconLogic);
